import automobyApi from '../Api';

export const useRemark = () => { 

   const fetchRemarks = (id, typeId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
         id: id,
         type_id: typeId 
      };
  
      automobyApi
        .post("/remark/list", requestData)
        .then(response => {
          resolve(response.data.remarks);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const addRemark = (newRemark) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/remark/add", newRemark)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  }; 

  const removeRemark = (remarkId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        remark_id: remarkId
      };
  
      automobyApi
        .post("/remark/remove", requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

   
  const remarkService = {
    fetchRemarks: fetchRemarks,
    addRemark: addRemark, 
    removeRemark: removeRemark,
   };
  

  return { remarkService };
 
}